import { create } from "zustand"
import { persist } from "zustand/middleware"

interface UIState {
  // Sidebar
  sidebarOpen: boolean
  sidebarCollapsed: boolean
  toggleSidebar: () => void
  setSidebarCollapsed: (collapsed: boolean) => void

  // Mobile menu (drawer)
  mobileMenuOpen: boolean
  setMobileMenuOpen: (open: boolean) => void

  // Active division (for multi-division support)
  selectedDivision: string | null
  setSelectedDivision: (divisionId: string | null) => void

  // Command palette
  commandPaletteOpen: boolean
  setCommandPaletteOpen: (open: boolean) => void

  // Global search
  globalSearchQuery: string
  setGlobalSearchQuery: (query: string) => void
  searchResultsOpen: boolean
  setSearchResultsOpen: (open: boolean) => void

  // Theme
  theme: "light" | "dark"
  setTheme: (theme: "light" | "dark") => void

  // App configuration (DOMAINS from server)
  domains: Record<string, string> | null
  setDomains: (domains: Record<string, string>) => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      // Sidebar
      sidebarOpen: true,
      sidebarCollapsed: false,
      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

      // Mobile menu (drawer)
      mobileMenuOpen: false,
      setMobileMenuOpen: (open) => set({ mobileMenuOpen: open }),

      // Division
      selectedDivision: null,
      setSelectedDivision: (divisionId) => set({ selectedDivision: divisionId }),

      // Command palette
      commandPaletteOpen: false,
      setCommandPaletteOpen: (open) => set({ commandPaletteOpen: open }),

      // Global search
      globalSearchQuery: "",
      setGlobalSearchQuery: (query) => set({ globalSearchQuery: query }),
      searchResultsOpen: false,
      setSearchResultsOpen: (open) => set({ searchResultsOpen: open }),

      // Theme
      theme: "light",
      setTheme: (theme) => set({ theme }),

      // App configuration
      domains: null,
      setDomains: (domains) => set({ domains }),
    }),
    {
      name: "ui-storage",
      partialize: (state) => ({
        sidebarCollapsed: state.sidebarCollapsed,
        selectedDivision: state.selectedDivision,
        theme: state.theme,
      }),
    }
  )
)
